
let iconAnchor = new google.maps.Point(55, 55);
let iconSize = new google.maps.Size(40, 40);

export let whereToStayIcon = {
  url: 'https://dev.visitwaterford.ie/wp-content/themes/visitwaterford/assets/images/SVG/where-to-stay-pin.svg',
  anchor: iconAnchor,
  scaledSize: iconSize,
  size: iconSize,
  optimize: false
};

export let thingsToDoIcon = {
  url: 'https://dev.visitwaterford.ie/wp-content/themes/visitwaterford/assets/images/SVG/things-to-do-pin.svg',
  anchor: iconAnchor,
  scaledSize: iconSize,
  size: iconSize,
  optimize: false
};

export let eatAndDrinkIcon = {
  url: 'https://dev.visitwaterford.ie/wp-content/themes/visitwaterford/assets/images/SVG/eat-and-drink-pin.svg',
  anchor: iconAnchor,
  scaledSize: iconSize,
  size: iconSize,
  optimize: false
};

export let festivalsIcon = {
  url: 'https://dev.visitwaterford.ie/wp-content/themes/visitwaterford/assets/images/SVG/festivals-pin.svg',
  anchor: iconAnchor,
  scaledSize: iconSize,
  size: iconSize,
  optimize: false
};

export let mapOptions = {
  disableDefaultUI: true,
  zoomControl: true,
  streetViewControl: false,
  signInControl: false,
  scrollwheel: false,
  scaleControl: false,
  rotateControl: false,
  panControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  zoom:11,
  mapTypeId: google.maps.MapTypeId.ROADMAP,
  styles: [
    {
      "featureType": "poi",
      "stylers": [
        { "visibility": "off" }
      ],

    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#5cc5d3"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#f1efe9"
            }
        ]
    },
  ]
};



// WEBPACK FOOTER //
// ./src/components/03-ui/44-maps/map-helpers.js